<template>
    <v-col cols="12">
        <v-row no-gutters>
            <AppStoreTabsItems
                v-model="selectedTab"
                :all-tabs="tabs"
            >
                <template v-slot:content="{tab}">
                    <component
                        :is="tab.component"
                        :is-selected="selectedTabName === tab.name"

                        @close="close"
                    />
                </template>
            </AppStoreTabsItems>
        </v-row>
    </v-col>
</template>

<script>
import { ref, computed } from "@vue/composition-api";
import { $t } from "@/i18n";
import AppStoreTabs from "@/components/AppStore/AppStoreDialogTabs";
import AppStoreTabsItems from "@/components/AppStore/AppStoreDialogTabsItems";
import EconomicDialogImportTab from "@/views/AppStore/Economic/Import/EconomicDialogImportTab";
import EconomicDialogOverviewTab from "@/views/AppStore/Economic/EconomicDialogOverviewTab";
import EconomicDialogSettingsTab from "./Settings/EconomicDialogSettingsTab";
import appStoreDialog from "@/store/modules/AppStoreDialog/appStoreDialog";
import { TAB_NAMES } from "../app-tabs";

export default {
    name: "EconomicDialogContent",
    components: {
        AppStoreTabs,
        AppStoreTabsItems,
        EconomicDialogImportTab,
        EconomicDialogOverviewTab,
    },
    props: {
        defaultTab: {
            type: String,
            default: ''
        }
    },
    setup(props, ctx) {
        const { appStoreDialogFlags, appStoreDialogGetters, appStoreDialogActions } = appStoreDialog()
        const allTabs = ref([
            {
                name: TAB_NAMES.OVERVIEW,
                text: $t("Overview"),
                component: EconomicDialogOverviewTab,
            },
            {
                name: TAB_NAMES.IMPORT,
                text: $t("Import"),
                component: EconomicDialogImportTab,
                if: appStoreDialogFlags.canSeeAllTabs
            },
            {
                name: TAB_NAMES.SETTINGS,
                text: $t("Settings"),
                component: EconomicDialogSettingsTab,
                if: appStoreDialogFlags.canSeeAllTabs
            },
        ]);


        appStoreDialogActions.setTabs(allTabs);
        const tabs = computed(() => appStoreDialogGetters.getTabs());
        const selectedTab = computed(() => appStoreDialogGetters.getSelectedTab());
        const selectedTabName = computed(() => appStoreDialogGetters.getSelectedTabName());

        if (props.defaultTab){
            appStoreDialogActions.updateCurrentTab(props.defaultTab)
        }

        const close = function(){
            ctx.emit('close')
        }

        return {
            tabs,
            selectedTab,
            selectedTabName,
            appStoreDialogFlags,
            close
        };
    }
};
</script>
